<template>
  <div class="admin">
    <!-- 팝업:공지사항 -->
    <div class="pop-up-wrap">
      <div
        class="pop-up button-wrap"
        style="
          width: auto;
          padding: 8px 10px;
          text-align: center;
          height: 250px;
          background-color: #f9f9f9 !important;
          margin-top: 3em;
        "
      >
        <div class="pop-header">
          <span
            class="title02"
            style="
              color: #757575;
              border-bottom: none;
              font-size: 26px;
              margin-top: 200px;
            "
            >스파로스 POS 사용 화면 선택</span
          >
        </div>
        <div class="pop-btn-list" style="display: inline">
          <button
            type="button"
            class="btn-pop btn-submit"
            style="
              width: 230px;
              display: inline-block;
              margin: 0px 16px;
              height: 108px;
              background-color: #ffffff;
              box-shadow: 8px 8px 40px 0px rgba(144, 144, 144, 0.2);
              border-radius: 12px;
            "
            @click="
              this.$store.dispatch('setBaskets', null);
              this.$router.push('/order/main');
            "
          >
            <!-- <img
              src="@/assets/images/btn-payment-01.png"
              style="width: 288px"
            /><br /> -->
            <span class="btnFont">선불형 매장</span>
            <span class="overlay"></span>
          </button>

          <button
            type="button"
            class="btn-pop btn-submit"
            style="
              width: 230px;
              display: inline-block;
              margin: 0px 16px;
              height: 108px;
              background-color: #ffffff;
              box-shadow: 8px 8px 40px 0px rgba(144, 144, 144, 0.2);
              border-radius: 12px;
            "
            @click="this.$router.push('/order/table')"
          >
            <!-- <img
              src="@/assets/images/btn-payment-02.png"
              style="width: 288px"
            /><br /> -->
            <span class="btnFont">후불형 매장</span>
            <span class="overlay"></span>
          </button>
        </div>
      </div>
      <div class="dimed"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  props: {},
  data() {
    return {};
  },
  methods: {},
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style-admin.css" scoped></style>
<style scoped>
.btn-pop:hover {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
    linear-gradient(0deg, #ffffff, #ffffff);
}
.dimed {
  background-color: #f9f9f9 !important;
}
.btnFont {
  font-family: Noto Sans KR;
  font-size: 24px;
  font-weight: 500;
  line-height: 34px;
  letter-spacing: -0.01em;
  text-align: left;
}
.title02 {
  font-family: Noto Sans KR;
  font-size: 32px;
  font-weight: 700;
  line-height: 45px;
  letter-spacing: -0.01em;
  text-align: left;
}
</style>


